customElements.get("facet-remove") || customElements.define("facet-remove", class extends HTMLElement {
  constructor() {
    super();
    const e = this.querySelector("a");
    e.setAttribute("role", "button"), e.addEventListener("click", this.closeFilter.bind(this)), 
    e.addEventListener("keyup", e => {
      e.preventDefault(), "SPACE" === e.code.toUpperCase() && this.closeFilter(e);
    });
  }
  closeFilter(e) {
    e.preventDefault(), (this.closest("facet-filters-form") || document.querySelector("facet-filters-form")).onActiveFilterClick(e);
  }
});